import { ReactNode } from 'react';

import { N60Footer } from '~/features/navigation/components/N60Footer/N60Footer';

import { CheckoutHeader } from './CheckoutHeader/CheckoutHeader';
import styles from './checkoutLayout.module.css';

export type CheckoutLayoutProps = {
	children?: ReactNode;
};

export const CheckoutLayout = ({ children }: CheckoutLayoutProps) => {
	return (
		<main className={styles.root}>
			<CheckoutHeader />
			<div className={styles.content}>{children}</div>
			<div className={styles.footer}>
				<N60Footer></N60Footer>
			</div>
		</main>
	);
};
